import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'

import { Button, Icon } from '../../..'
import { PriceTypes } from '../../../../utils'
import {
  PricingContext,
  useCartActions,
  useFeatureFlags,
  useTranslation,
} from '../../../../utils/providers'
import { trackAddToCart } from '../../../../utils/Alphapet/tracking'

function AddToCartButton({
  productData,
  selectedOptions = {},
  variant = 'primary',
  trackingData,
  qty = 1,
}) {
  const { pricingContext, customCouponingContext } =
    useContext(PricingContext) || {}
  const cartActions = useCartActions()
  const { isFeatureEnabled } = useFeatureFlags()
  const { t } = useTranslation()
  const [isLoading, setLoading] = useState(false)

  const addToCartAction = async () => {
    setLoading(true)
    try {
      const { priceType, specialPrice } = pricingContext || {}
      const isAboEnabled =
        isFeatureEnabled('abo') && priceType === PriceTypes.PRICE_ABO
      const ret = await cartActions.addItem({
        productData,
        qty,
        selectedOptions,
        isAboEnabled,
        couponCode: customCouponingContext?.addToCartCoupon,
        trackingData,
      })
      if (ret.status === 'ok') {
        const { items: cartItems, totals, quoteIdHash } = ret
        const cartTotals = totals?.find((t) => t.code === 'grand_total')?.value

        trackAddToCart({
          productData,
          qty,
          cartTotals,
          cartItems,
          specialPrice,
          trackingData,
          quoteIdHash,
        })
      }
    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  }

  return (
    <Button
      variant={variant}
      className="product-action-bubble"
      title={t('PRODUCT_TILE_ADD_TO_CART')}
      isLoading={isLoading}
      onClick={addToCartAction}
      data-testid="btn-add-to-cart"
    >
      <Icon symbol="cf-cart-o" className="font-size-base" />
    </Button>
  )
}

AddToCartButton.propTypes = {
  productData: PropTypes.object.isRequired,
  selectedOptions: PropTypes.object,
  variant: PropTypes.string,
  trackingData: PropTypes.object,
  qty: PropTypes.number,
}

export default AddToCartButton
